import _ from 'lodash';

import { withoutUndefined } from './dateSettings';
import { StoredGadget } from './types';

// A gadget's gadget-level settings, when it has any. Off flags and the
// report mode's default are left out, so they read back as absent.
export const readGadgetSettings = (
  stored: StoredGadget,
): Studio.GadgetSettings | undefined => {
  const settings: Studio.GadgetSettings =
    stored.kind === 'dashboard'
      ? withoutUndefined({
          isBonusPeriodMode: stored.gadget.isBonusPeriodMode || undefined,
          weekStartsOnOverride: stored.gadget.weekStartsOnOverride || undefined,
          isEntityFilterEnabled:
            stored.gadget.isEntityFilterEnabled || undefined,
          isDefaultFiltersDisabled:
            stored.gadget.isDefaultFiltersDisabled || undefined,
        })
      : withoutUndefined({
          isDefaultFiltersDisabled:
            stored.gadget.isDefaultFiltersDisabled || undefined,
          defaultDatasetFiltersMode:
            stored.gadget.defaultDatasetFiltersMode &&
            stored.gadget.defaultDatasetFiltersMode !== 'report'
              ? stored.gadget.defaultDatasetFiltersMode
              : undefined,
        });
  return _.isEmpty(settings) ? undefined : settings;
};

// Whether a dashboard block filters by the selected entity. A new gadget
// does unless turned off, as the classic editor has it; a saved one only if
// it was saved on.
export const isEntityFilterOn = ({
  settings,
  isNewGadget,
}: {
  settings: Studio.GadgetSettings | undefined;
  isNewGadget: boolean;
}): boolean =>
  settings && settings.isEntityFilterEnabled !== undefined
    ? settings.isEntityFilterEnabled
    : isNewGadget;
